/**
 * idleblade `GlobalDataWrap.ParseFlexible`의 TS 포팅 — 시각/기간 문자열을 **밀리초(ms)** 로.
 *
 * C# TimeSpan struct가 TS에 없어 number(ms)로 표현한다. 파싱 우선순위(idleblade 동형):
 *  1) `"H:mm:ss"` / `"HH:mm:ss"` — 시(H)는 24 이상 허용(기간), 분·초는 0~59.
 *  2) `"D.HH:mm:ss"` — 일수 포함 기간(C# `TimeSpan.Parse("1.00:00:00")` 대응).
 * 어느 것도 아니면 throw(조기 실패).
 */
export function parseFlexibleTimeSpan(value: string): number {
  if (value == null) throw new Error("parseFlexibleTimeSpan: value is null");
  const v = value.trim();

  // 1) H:mm:ss (H 24+ 허용)
  const hms = /^(\d+):([0-5]?\d):([0-5]?\d)$/.exec(v);
  if (hms) {
    const h = Number(hms[1]);
    const m = Number(hms[2]);
    const s = Number(hms[3]);
    return ((h * 60 + m) * 60 + s) * 1000;
  }

  // 2) D.HH:mm:ss (일수 포함 기간)
  const dhms = /^(\d+)\.(\d{1,2}):([0-5]?\d):([0-5]?\d)$/.exec(v);
  if (dhms) {
    const d = Number(dhms[1]);
    const h = Number(dhms[2]);
    const m = Number(dhms[3]);
    const s = Number(dhms[4]);
    return (((d * 24 + h) * 60 + m) * 60 + s) * 1000;
  }

  throw new Error(`parseFlexibleTimeSpan: invalid format '${value}'`);
}
